export default __webpack_public_path__ + "static/media/stew_buckwheat.f23d3763.jpg";